<div class="_page-header-component">
	<div class="_button-container _left">
		<button type="button" class="_button _back-button" (click)="goBack()" *ngIf="showBackButton">
			<ion-icon src="./assets/icons/arrow-left.svg"></ion-icon>
			<span *ngIf="template === 'desktop'">{{ 'BUTTONS.PREVIOUS' | translate}}</span>
		</button>
		<ng-content select="[left]"></ng-content>
	</div>
	<div class="_title-container">
		<p class="_title" *ngIf="title">{{title}}</p>
		<p class="_subtitle" *ngIf="subtitle">{{subtitle}}</p>
	</div>
	<div class="_button-container _right">
		<ng-content select="[right]"></ng-content>
	</div>
</div>
